export const kMeanClass = "mean"
export const kMeanType = "Mean"
export const kMeanPrefix = "ADRN"
export const kMeanLabelKey = "Mean"
export const kMeanUndoAddKey = "DG.Undo.graph.showPlottedMean"
export const kMeanRedoAddKey = "DG.Redo.graph.showPlottedMean"
export const kMeanUndoRemoveKey = "DG.Undo.graph.hidePlottedMean"
export const kMeanRedoRemoveKey = "DG.Redo.graph.hidePlottedMean"
export const kMeanValueTitleKey = "DG.PlottedAverageAdornment.meanValueTitle"
